import { Injectable } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { SectorsService } from './API/sectors.service';
import { GeographiesService } from './API/geographies.service';
import { TotBatchService } from './API/tot-batch.service';
// tslint:disable-next-line:import-blacklist
import { Observable, Subject } from 'rxjs';
import { BatchService } from 'projects/shared/src/app/shared/batch.service';

declare const toastr;

@Injectable({ providedIn: 'root' })
export class ApplicantDataService {
	sectors: any;
	subSectors: any;
	jobRoles: any;
	states: any;
	districts: any;
	subDistricts: any;
	batchTypes: any;
	searchBatchesForm: FormGroup;
	trFilterForm: FormGroup;
	private subject = new Subject<any>();
	constructor(
		private sectorsService: SectorsService,
		private _formBuilder: FormBuilder,
		private geographiesService: GeographiesService,
		private sharedBatchService: BatchService,
		private totBatchService: TotBatchService
	) {
		this.searchBatchesForm = _formBuilder.group({
			state: [null],
			district: [null],
			subDistrict: [null],
			sector: [null],
			// subSector: [null],
			jobRole: [null],
			keyword: [''],
			type: [''],
			applicantType:['', Validators.required],
			startDate: [''],
			enddate: ['']
		});
		this.trFilterForm = _formBuilder.group({
			state: [null],
			district: [null],
			subDistrict: [null],
			sector: [null],
			// subSector: [null],
			jobRole: [null],
			applicantType: [null, Validators.required],
			status: [null],
			startDate: [''],
			endDate: ['']
		});
	}

	setData(message: string, tab?: string ) {
		this.subject.next({ text: message, activeTab: tab});
	}

	getData(): Observable<any> {
		return this.subject.asObservable();
	}
	// for applicant :begin
	getSectorsTR() {
		this.sectorsService.getSectors().subscribe(
			sector => {
				if (sector) {
					this.sectors = sector;
					console.log(this.sectors);
				}
			},
			error => {
				console.log(
					`There was an error fetching current user details = ${error}`
				);
			}
		);
	}
	getSubSectorsTR() {
		this.subSectors = [];
		this.jobRoles = [];
		// this.searchBatchesForm.get('subSector').setValue('');
		this.trFilterForm.get('jobRole').setValue('');
		console.log(this.trFilterForm.get('sector').value);
		this.sectorsService
			.getSubSectors(this.trFilterForm.get('sector').value.sectorID)
			.subscribe(
				subSectors => {
					if (subSectors) {
						this.subSectors = subSectors['subSectors'];
						console.log(this.subSectors);
					}
				},
				error => {
					console.log('Error in fetching subsectors : ', error);
				}
			);
	}
	getJobRolesTR() {
		const selectedSector = this.trFilterForm.get('sector').value;
		// const selectedSubSector = this.trFilterForm.get('subSector').value;
		this.jobRoles = [];
		this.trFilterForm.get('jobRole').setValue(null);
		if (selectedSector) {
			this.sectorsService
				.getJobRoles(selectedSector ? selectedSector.sectorID : '' )
				.subscribe(jobRoles => {
					console.log("Jb Role",jobRoles);

					if (jobRoles.data === null) {
						toastr.error(
							'No Job Roles found for the selected criteria !'
						);
					} else {
						this.jobRoles = jobRoles.data;
						console.log('jobs', this.jobRoles);
					}
				});
		}
	}
	getStatesTR() {
		this.geographiesService.getStates().subscribe(
			statesDetails => {
				this.states = statesDetails.states;
				console.log(this.states);
			},
			error => {
				console.log(
					`There was an error in getting the states: ${error}`
				);
			}
		);
	}
	getDistrictsTR() {
		console.log("HHIII");

		this.districts = [];
		this.subDistricts = [];
		const selectedState = this.trFilterForm.get('state').value;
		if (this.sharedBatchService.batchSearchCriteria) {
			if (
				selectedState.code !==
				this.sharedBatchService.batchSearchCriteria.location.state.code
			) {
				this.trFilterForm.get('district').setValue(null);
				this.trFilterForm.get('subDistrict').setValue(null);
			}
		} else {
			this.trFilterForm.get('district').setValue(null);
			this.trFilterForm.get('subDistrict').setValue(null);
		}
		this.geographiesService.getDistricts(selectedState.code).subscribe(
			districts => {
				console.log("testing");

				this.districts = districts.districts;
			},
			error => {
				console.log(
					`There was an error in getting the districts: ${error}`
				);
			}
		);
	}
	getSubDistrictsTR() {
		this.subDistricts = [];
		const selectedDistrict = this.trFilterForm.get('district').value;
		console.log(selectedDistrict);
		if (selectedDistrict) {
			this.geographiesService.getTehsil(selectedDistrict.code).subscribe(
				subDistricts => {
					this.subDistricts = subDistricts.subDistricts;
				},
				error => {
					console.log(
						`There was an error in getting the sub-districts: ${error}`
					);
				}
			);
			if (this.sharedBatchService.batchSearchCriteria) {
				if (
					selectedDistrict.code !==
					this.sharedBatchService.batchSearchCriteria.location
						.district.code
				) {
					this.trFilterForm.get('subDistrict').setValue(null);
				}
			} else {
				this.trFilterForm.get('subDistrict').setValue(null);
			}
		}
	}


	// End

	getSectors() {
		this.sectorsService.getSectors().subscribe(
			sector => {
				if (sector) {
					this.sectors = sector;
					console.log(this.sectors);
				}
			},
			error => {
				console.log(
					`There was an error fetching current user details = ${error}`
				);
			}
		);
	}
	getSubSectors() {
		this.subSectors = [];
		this.jobRoles = [];
		// this.searchBatchesForm.get('subSector').setValue('');
		this.searchBatchesForm.get('jobRole').setValue('');
		console.log(this.searchBatchesForm.get('sector').value);
		this.sectorsService
			.getSubSectors(this.searchBatchesForm.get('sector').value.sectorID)
			.subscribe(
				subSectors => {
					if (subSectors) {
						this.subSectors = subSectors['subSectors'];
						console.log(this.subSectors);
					}
				},
				error => {
					console.log('Error in fetching subsectors : ', error);
				}
			);
	}
	getJobRoles() {
		const selectedSector = this.searchBatchesForm.get('sector').value;
		// const selectedSubSector = this.searchBatchesForm.get('subSector').value;
		this.jobRoles = [];
		this.searchBatchesForm.get('jobRole').setValue(null);
		if (selectedSector) {
			this.sectorsService
				.getJobRoles(selectedSector ? selectedSector.sectorID : '' )
				.subscribe(jobRoles => {
					if (jobRoles.data === null) {
						toastr.error(
							'No Job Roles found for the selected criteria !'
						);
					} else {
						this.jobRoles = jobRoles.data;
						console.log('jobs', this.jobRoles);
					}
				});
		}
	}
	getStates() {
		this.geographiesService.getStates().subscribe(
			statesDetails => {
				this.states = statesDetails.states;
				console.log(this.states);
			},
			error => {
				console.log(
					`There was an error in getting the states: ${error}`
				);
			}
		);
	}
	getDistricts() {
		this.districts = [];
		this.subDistricts = [];
		const selectedState = this.searchBatchesForm.get('state').value;
		if (this.sharedBatchService.batchSearchCriteria) {
			if (
				selectedState.code !==
				this.sharedBatchService.batchSearchCriteria.location.state.code
			) {
				this.searchBatchesForm.get('district').setValue(null);
				this.searchBatchesForm.get('subDistrict').setValue(null);
			}
		} else {
			this.searchBatchesForm.get('district').setValue(null);
			this.searchBatchesForm.get('subDistrict').setValue(null);
		}
		this.geographiesService.getDistricts(selectedState.code).subscribe(
			districts => {
				this.districts = districts.districts;
			},
			error => {
				console.log(
					`There was an error in getting the districts: ${error}`
				);
			}
		);
	}
	getSubDistricts() {
		this.subDistricts = [];
		const selectedDistrict = this.searchBatchesForm.get('district').value;
		console.log(selectedDistrict);
		if (selectedDistrict) {
			this.geographiesService.getTehsil(selectedDistrict.code).subscribe(
				subDistricts => {
					this.subDistricts = subDistricts.subDistricts;
				},
				error => {
					console.log(
						`There was an error in getting the sub-districts: ${error}`
					);
				}
			);
			if (this.sharedBatchService.batchSearchCriteria) {
				if (
					selectedDistrict.code !==
					this.sharedBatchService.batchSearchCriteria.location
						.district.code
				) {
					this.searchBatchesForm.get('subDistrict').setValue(null);
				}
			} else {
				this.searchBatchesForm.get('subDistrict').setValue(null);
			}
		}
	}
	getBatchTypes(role) {
		this.totBatchService.getBatchType().subscribe((batchTypes) => {
			this.batchTypes = batchTypes.batchType.filter((batchType) => {
				return (batchType.search(new RegExp(role)) !== -1);
			});
		}, error => {
			console.log(`There was error in getting list of batch types : ${error}`);
		});
	}
}
